module.exports = __webpack_public_path__ + "img/porre_groent.f0d8b821.jpg";